<template>
    <van-pull-refresh v-model="refreshing" class="base-list" @refresh="onRefresh">
        <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="() => onLoad(false, filter)"
        >
            <slot :data="data" />
        </van-list>
    </van-pull-refresh>
</template>

<script>
    import { PullRefresh, List } from 'vant'
    export default {
        name: 'BaseList',
        components: {
            [PullRefresh.name]: PullRefresh,
            [List.name]: List,
        },
        props: {
            api: {
                type: String,
                default: '',
            },
            filter: {
                type: Object,
                default: () => {},
            },
            mappingData: {
                type: Function,
                default: null,
            },
            pageSize: {
                type: Number,
                default: 6,
            },
        },
        data() {
            return {
                data: [], // 数据
                loading: false,
                finished: false,
                refreshing: false,
            }
        },
        methods: {
            refresh() {
                this.refreshing = true
                this.onLoad(true, this.filter)
            },
            onLoad(refresh, filter = {}) {
                if (
                    this.data.length > 0 &&
                    this.data.length < this.pageSize &&
                    !refresh
                ) {
                    this.finished = true
                    return
                }
                const pageIndex = refresh
                    ? 1
                    : Math.floor(this.data.length / this.pageSize) + 1
                this.$request
                    .post(`/transformToAfter${this.api}`, {
                        pageIndex,
                        pageSize: this.pageSize,
                        ...filter,
                    })
                    .then((res) => {
                        if (refresh) {
                            this.data.splice(0, this.data.length)
                            this.refreshing = false
                            this.finished = false
                        }
                        this.loading = false
                        if (
                            res.data &&
                            res.data.length > 0 &&
                            this.data.length + res.data.length <= res.total
                        ) {
                            this.data = this.data.concat(
                                this.mappingData ? this.mappingData(res.data, pageIndex) : res.data,
                            )
                        } else {
                            this.finished = true
                        }
                    })
                    .catch(() => {
                        this.finished = true
                    })
            },
            onRefresh() {
                this.refreshing = true
                this.onLoad(true, this.filter)
            },
        },
    }
</script>

<style>
.base-list{
  background: #ffffff;
}
</style>
